export const newActionExcludedObjects = [
    '$nautical_ship',
    '$nautical_port',
    '$companies_company',
];
